import { useIntl } from 'react-intl'

/**
 * Returns a lookup of CruiseDurationOptions.value -> localised label.
 * Shared between CruiseWhenSelectHowLong and CruiseSearchFiltersMobile.
 *
 * `intl.formatMessage` already caches by descriptor id, so no extra
 * memoisation is needed here.
 */
function useCruiseDurationLabels(): Record<string, string> {
  const intl = useIntl()

  return {
    'Any duration': intl.formatMessage({
      id: '1-V-v57Py1xxPhhXcw9p',
      defaultMessage: 'Any duration',
    }),
    '1 - 7 Nights': intl.formatMessage({
      id: 'gP57FALJPyI5Se0XYK_v',
      defaultMessage: '1 - 7 Nights',
    }),
    '8 - 14 Nights': intl.formatMessage({
      id: 'uHftbHThb7VP03HiRdiN',
      defaultMessage: '8 - 14 Nights',
    }),
    '15+ Nights': intl.formatMessage({
      id: 'GXcT7MDx62IcY3oLmjfM',
      defaultMessage: '15+ Nights',
    }),
  }
}

export default useCruiseDurationLabels
